import { NavigationContainer } from '@react-navigation/native';
import { createNativeStackNavigator } from '@react-navigation/native-stack';
import * as React from 'react';
import { CameraScreen } from './screens/CameraScreen';
import { HomeScreen } from './screens/HomeScreen';
import { LoginScreen } from './screens/LoginScreen';
import { SplashScreen } from './screens/SplashScreen';

export interface IAppProps {
}

const Stack = createNativeStackNavigator();

export function App(props: IAppProps) {
    return (
        <NavigationContainer>
            <Stack.Navigator initialRouteName="SplashScreen">

                <Stack.Group screenOptions={{ headerShown: false }}>
                    <Stack.Screen name="Home" component={HomeScreen} />
                    <Stack.Screen name="Camera" component={CameraScreen} />
                    <Stack.Screen name="SplashScreen" component={SplashScreen} />
                    <Stack.Screen name="Login" component={LoginScreen} />
                </Stack.Group>

                <Stack.Group screenOptions={{ presentation: 'modal' }}>

                </Stack.Group>

            </Stack.Navigator>
        </NavigationContainer>
    );
}

export default App;

